import { composeIO } from 'react-compose-io'
import { downloadRelatorioIO } from './DownloadRelatorio.IO'
import { DownloadRelatorioView } from './DownloadRelatorio.View'

export const DownloadRelatorio = composeIO(DownloadRelatorioView, downloadRelatorioIO)
